/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ReportDataType, StatisticsState } from "~/features/statistics/types";
import { RootState } from "~/state/types";
import { ReportType } from "~/types";

const getState = (state: RootState) => state.statistics;

const createSelector =
  <TSelected = unknown>(selector: (state: StatisticsState) => TSelected): ((rootState: RootState) => TSelected) =>
  (rootState) =>
    selector(getState(rootState));

export const selectStatisticsIsReportLoading = createSelector((state) => state.isReportLoading);
export const selectStatisticsIsFullscreen = createSelector((state) => state.isFullscreen);
export const selectStatisticsOpenedFromReportTracker = createSelector((state) => state.openedFromReportTracker);
export const selectStatisticsShouldGetReport = createSelector((state) => state.shouldGetReport);

export const selectStatisticsActiveTab = createSelector((state) => state.tab.activeTab);

export const selectStatisticsColumns = createSelector((state) => state.tab.columns);

export const selectStatisticsFilter = createSelector((state) => state.filter);

export const selectReferrerSitesStatus = createSelector((state) => state.referrerSites.meta.status);

export const selectEmailSubscriptionStatus = createSelector((state) => state.emailSubscription.meta.status);

export const selectReferrerSitesById = createSelector((state) => state.referrerSites.data.sites.byId);

export const selectReferrerSitesSortedIds = createSelector((state) => state.referrerSites.data.sites.sortedIds);

export const selectReferrerSitesByName = createSelector((state) => state.referrerSites.data.sites.byName);

export const selectLocalReports = createSelector((state) => state.localReports);

export const selectSpecificReportData = (reportType: ReportType) =>
  createSelector((state) => state.localReports[reportType].data as ReportDataType);

export const selectSpecificReportStatus = (reportType: ReportType) =>
  createSelector((state) => state.localReports[reportType].meta.status);

export const selectStatisticsEmailSubscriptionData = createSelector((state) => state.emailSubscription.data);
export const selectScrollToTable = createSelector((state) => state.scrollToTable);
